import React, { useState, useEffect } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Box, 
  Button, 
  IconButton,
  useTheme,
  useMediaQuery,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText
} from '@mui/material';
import { Search as SearchIcon, Menu as MenuIcon, Close as CloseIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import GlobalSearch from './GlobalSearch';
import UserProfile from '../auth/UserProfile';
import LanguageSelector from './LanguageSelector';

const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false); // Add this line
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  console.log(location.pathname); // "/plans", "/dishes", etc.

  const currentTab = location.pathname; // "/dishes" 

  const handleTabClick = (newPath) => {
    navigate(newPath);
    setMobileMenuOpen(false); // Add this line to close menu after click
  };

  const handleSearchResult = (result) => {
    if (result.type === 'dish') {
      navigate('/dishes');
    } else if (result.type === 'ingredient') {
      navigate('/ingredients');
    } else if (result.type === 'restaurant') {
      navigate('/restaurants');
    }
  };

  const pages = [
    { label: t('common.navigation.menu').toUpperCase(), path: '/dishes' },
    { label: t('common.labels.ingredients').toUpperCase(), path: '/ingredients' },
    { label: t('plans.title').toUpperCase(), path: '/plans' },
    { label: t('restaurants.title').toUpperCase(), path: '/restaurants' },
    { label: t('analytics.title').toUpperCase(), path: '/analytics' },
    { label: t('shopping.title', { defaultValue: 'Shopping' }).toUpperCase(), path: '/shopping' },
    { label: t('tags.title', { defaultValue: 'Tags' }).toUpperCase(), path: '/tags' },
  ];

  useEffect(() => {
    const handleOpenSearch = () => {
      setSearchOpen(true);
    };

    window.addEventListener('openSearch', handleOpenSearch);
    return () => window.removeEventListener('openSearch', handleOpenSearch);
  }, []);

  return (
    <>
      <AppBar position="static">
        <Toolbar>
          {/* Add this hamburger menu button */}
          {isMobile && (
            <IconButton
              color="inherit"
              onClick={() => setMobileMenuOpen(true)}
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>
          )}

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page) => (
              <Button
                key={page.path}
                onClick={() => handleTabClick(page.path)}
                sx={{
                  my: 2,
                  color: 'white',
                  display: 'block',
                  backgroundColor: currentTab === page.path ? 'rgba(255,255,255,0.2)' : 'transparent'
                }}
              >
                {page.label}
              </Button>
            ))}
          </Box>

          <IconButton
            color="inherit"
            onClick={() => setSearchOpen(true)}
            sx={{ ml: 2 }}
            title={t('search.placeholder')}
          >
            <SearchIcon />
          </IconButton>

          <Box sx={{ ml: 1 }}>
            <LanguageSelector variant="dropdown" />
          </Box>

          <UserProfile />
        </Toolbar>
      </AppBar>

      {/* Add this Drawer component */}
      <Drawer
        anchor="left"
        open={mobileMenuOpen}
        onClose={() => setMobileMenuOpen(false)}
      >
        <Box sx={{ width: 250 }}>
          <List>
            {pages.map((page) => (
              <ListItem key={page.path}>
                <ListItemButton onClick={() => handleTabClick(page.path)}>
                  <ListItemText primary={page.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>

      <GlobalSearch
        open={searchOpen}
        onClose={() => setSearchOpen(false)}
        onResultSelect={handleSearchResult}
      />
    </>
  );
};

export default Navigation;